import { useQuery } from '@oneaudi/onegraph-client';
import { useMarketConfig } from '~/app/market-config';
import { groupItemsByGroupAndFamily } from '~/app/utils/group-items';
import { ConfigurationOverviewDocument } from '~/graphql/__generated__/graphql';
import { useCatalog, useConfigurator } from '~/graphql/hooks/use-configurator';
import { imageSetFilter } from '~/graphql/hooks/use-configured-car-queries';

/**
 * Returns the selected options from the configurator.
 */
export function useSelectedEquipment() {
	const { config } = useMarketConfig();
	const { carIdentifier } = useConfigurator();
	const { trimlines } = useCatalog();

	const { data, loading } = useQuery(ConfigurationOverviewDocument, {
		variables: {
			configuredCar: carIdentifier,
			financingInput: config.financingInput,
			filter: {
				filterByFeatureState: ['selected'],
			},
			imageTypeFilterInput: imageSetFilter,
			financingEnabled: config.enablePartsRateCalculation && config.enableFinancingServices,
		},
		returnPartialData: true,
		fetchPolicy: 'no-cache',
	});

	const catalog = data?.configuredCar.catalog;
	const model = catalog?.models?.data?.[0];

	const nonStandardFeatures = catalog?.features.data.filter((item) => !item.status.standard && item.status.selected);

	const nonAccessories = nonStandardFeatures?.filter((item) => item.featureGroup !== 'ACCESSORIES');
	const accessories = nonStandardFeatures?.filter((item) => item.featureGroup === 'ACCESSORIES');

	const featuresAndPackages = groupItemsByGroupAndFamily([
		...(nonAccessories ?? []),
		...(catalog?.packagesDetails.data ?? []),
	]);

	return {
		driveTrain: trimlines?.flatMap((t) => t.driveTrains)?.find((item) => item.status.selected),
		configuration: {
			model,
			featuresAndPackages: featuresAndPackages.filter((item) => item.id.toLocaleLowerCase() !== 'weitere'),
			accessories,
		},
		loading,
	};
}
